import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreativesResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreativesResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreativesResult>({
    results: arrayOf(objectOf({ api_campaign_id: string, name: string, variant_count: number })),
  });
